import type { MisconceptionDefinition } from './types'

import { nlRegioStedenMisconceptions } from './topo/nlRegioSteden'
import { waterEilandenGrensMisconceptions } from './topo/waterEilandenGrens'
import { klimaatLandschapMisconceptions } from './topo/klimaatLandschap'
import { euHoofdstedenMisconceptions } from './topo/euHoofdsteden'
import { nlWaterMisconceptions } from './topo/nlWater'
import { euLandMisconceptions } from './topo/euLand'

/**
 * TOPO — Topografie misconcepties (barrel).
 *
 * Deze barrel concateneert zes sub-registries onder `./topo/`:
 * - `nlRegioSteden`      — NL steden, provincies, regio's en hoofdsteden
 * - `waterEilandenGrens` — wateren, eilanden, buurlanden en continenten
 * - `klimaatLandschap`   — landschap, gebergte en klimaat
 * - `euHoofdsteden`      — EU hoofdsteden en NL buurland/windstreken
 * - `nlWater`            — NL wateren (rivieren, zeeën, meren, kanalen)
 * - `euLand`             — landvormen en regio's van Europa
 */
export const TOPO_MISCONCEPTIONS: MisconceptionDefinition[] = [
  ...nlRegioStedenMisconceptions,
  ...waterEilandenGrensMisconceptions,
  ...klimaatLandschapMisconceptions,
  ...euHoofdstedenMisconceptions,
  ...nlWaterMisconceptions,
  ...euLandMisconceptions,
]
